module.exports = __webpack_public_path__ + "static/media/2DGACM5.9c94002a.jpg";